/*
 * Copyright (c) 2022. Dave van Rijn Development
 */

import {AppNavigator} from '@dvrd/dvr-controls';

import './util/startup';
import React, {useContext, useEffect} from 'react';
import {Outlet} from 'react-router';
import AdminHeaderController from './components/admin/header/adminHeaderController';
import {AppContext} from './components/context/appContext';
import Footer from './components/footer/footer';
import Header from './components/header/header';
import PopupController from './components/misc/popupController';
import useScroller from './components/misc/scroller';
import UpButton from './components/misc/upButton';
import NavBlocks from './components/navBlock/navBlocks';
import User from './models/userModel';
import {ADMIN_PATH} from './util/constants';
import {deviceCookieExists} from './util/cookieUtil';
import LanguageToggle from './components/misc/languageToggle';
import CalendarController from "./components/pages/calendar/calendarController";

export default function App() {
    const context = useContext(AppContext);
    useScroller();

    function validateUser() {
        if (deviceCookieExists())
            User.get((user: User | null, success: boolean) => {
                if (success) context.onChangeContext({user});
            });
    }

    useEffect(() => {
        validateUser();
    }, []);

    return (
        <>
            {!context.calendarOnly && <AppNavigator/>}
            {!context.calendarOnly && <AdminHeaderController/>}
            <div className='page-wrapper'>
                {context.calendarOnly ? <CalendarController/> : <>
                    <LanguageToggle/>
                    <Header/>
                    <div className='page'>
                        <Outlet/>
                        {!location.pathname.includes(ADMIN_PATH) && <NavBlocks/>}
                    </div>
                    <UpButton/>
                    <Footer/>
                </>}
            </div>
            {!context.calendarOnly && <PopupController/>}
        </>
    );
}